define('QuickAdd.View.Ext', [
    'QuickAdd.View'
  ], function (
      View
) {
    'use strict';
  
    return _.extend( View.prototype, {
        onItemSelected: function(result) {
            // As the item searcher has been thought to work with items the property is called selectedItem, but we changed in the installed
            // plugin to use Products
            var product = result.selectedItem;
            var item;
    
            if (product) {
                item = product.getItem();
    
                this.model.set('quickaddSearch', item.get('_name'));
                this.model.set('selectedProduct', product);

                var newMinimum = !!item.get('custitem_mhi_min_order_qty') ? item.get('custitem_mhi_min_order_qty') : 1;

                this.setDefaultQuantity( newMinimum, item.get('internalid'));
                this.$('[name="quantity"]').attr('min', newMinimum);
                this.$('[name="quantity"]').attr('step', newMinimum);
                this.$('[name="quantity"]').val( newMinimum );
                this.$('[name="quantity"]').focus();
                this.selectAll();

                if ( newMinimum > 1 ) { 
                    this.$('[id="quick-add-minimum-order"]').html('<br><p>This item must be ordered in quantities of '+newMinimum+'</p>')
                }
                
                var minimum_quantity = item.get('_minimumQuantity', true);
    
                if (minimum_quantity > 1) {
                    this.$('[data-type="minimum-quantity"]').html(
                        Utils.translate('Minimum of $(0) required', minimum_quantity)
                    );
                }
    
                this.$('[data-validation-error="block"]').remove();
            } else {
                this.model.unset('selectedProduct');
                this.$('[data-type="minimum-quantity"]').empty();
            }
        },

    });

  });
  
